module.exports = "<p>\n  tenant-information works!\n</p>\n"